import { createContext, useState } from "react";

const AdvancedExchangeContext = createContext({
  cart: [],
  setCart: (cart: any[]) => {},
  backupCart: [],
  setBackupCart: (backupCart: any[] | null) => {},
  // All the products in which the products were selected for an advanced exchange
  advancedExchangeProducts: [],
  setAdvancedExchangeProducts: (advancedExchangeReturnProducts: []) => {},
  cartMenuOpen: false,
  setCartMenuOpen: (cartMenuOpen: boolean) => {},
  cartVisible: false,
  setCartVisible: (cartVisible: boolean) => {},
});

const AdvancedExchangeContextProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [backupCart, setBackupCart] = useState(null);
  const [advancedExchangeProducts, setAdvancedExchangeProducts] = useState([]);
  const [cartMenuOpen, setCartMenuOpen] = useState(false);
  const [cartVisible, setCartVisible] = useState(false);

  return (
    <AdvancedExchangeContext.Provider
      value={{
        cart,
        setCart,
        backupCart,
        setBackupCart,
        advancedExchangeProducts,
        setAdvancedExchangeProducts,
        cartMenuOpen,
        setCartMenuOpen,
        cartVisible,
        setCartVisible,
      }}
    >
      {children}
    </AdvancedExchangeContext.Provider>
  );
};

export { AdvancedExchangeContext, AdvancedExchangeContextProvider };
